import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, MessagesSquare, KanbanSquare, Users, MapPin, Wallet, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "nav-dashboard", end: true },
  { to: "/chat", label: "Chat PARAFIX", icon: MessagesSquare, testid: "nav-chat" },
  { to: "/dossiers", label: "Suivi des dossiers", icon: KanbanSquare, testid: "nav-dossiers" },
  { to: "/budgets", label: "Suivi des budgets", icon: Wallet, testid: "nav-budgets" },
  { to: "/agents", label: "Annuaire des agents", icon: Users, testid: "nav-agents" },
  { to: "/territoire", label: "Suivi territorial", icon: MapPin, testid: "nav-territoire" },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[#F9FAFB]">
      <aside className="w-64 shrink-0 bg-sidebar text-white flex flex-col" data-testid="sidebar">
        <div className="px-5 py-6 border-b border-white/10">
          <div className="flex items-center gap-2 text-gold">
            <ShieldCheck className="h-5 w-5" strokeWidth={1.5} />
            <span className="font-heading font-extrabold tracking-tight text-base text-white">SG CORE</span>
          </div>
          <p className="mt-1 text-[11px] leading-tight text-slate-400 uppercase tracking-wide">
            Cellule d'appui IA · Secrétariat général
          </p>
          <p className="text-[11px] text-slate-500">MCI — République du Tchad</p>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive ? "bg-navy text-white" : "text-slate-300 hover:bg-sidebar-hover hover:text-white"
                }`
              }
            >
              <n.icon className="h-4 w-4" strokeWidth={1.5} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-white/10">
          <div className="px-2 mb-2">
            <p className="text-sm font-medium truncate" data-testid="current-user-name">{user?.name}</p>
            <p className="text-[11px] text-slate-400 capitalize">{user?.role}</p>
          </div>
          <button
            data-testid="logout-button"
            onClick={() => { logout(); navigate("/login"); }}
            className="flex w-full items-center gap-2 px-3 py-2 rounded-sm text-sm text-slate-300 hover:bg-sidebar-hover hover:text-white transition-colors"
          >
            <LogOut className="h-4 w-4" strokeWidth={1.5} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="max-w-[1600px] mx-auto w-full">{children}</div>
      </main>
    </div>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <header className="border-b border-border bg-white px-8 py-5 flex items-center justify-between sticky top-0 z-20">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-navy">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {actions}
    </header>
  );
}
